import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonListDataItem } from '../../buttons-list.data';
import ButtonsListItemComponents from './buttons-list-item.components';

interface ButtonsListItemContentProps {
  item: ButtonListDataItem;
  onClickHandler: () => void;
  isGreyed: boolean;
}
const { Container, StyledText, HoveredText } = ButtonsListItemComponents;

const ButtonsListItemContent: React.FunctionComponent<ButtonsListItemContentProps> = ({
  item,
  onClickHandler,
  isGreyed
}) => {
  const { t } = useTranslation();

  return (
    <Container onClick={onClickHandler} isActive={!isGreyed}>
      <img src={item.img} alt={t(`dispatchPage.buttons.${item.id}`)} />
      <StyledText tParams={`dispatchPage.buttons.${item.id}`} />
      <HoveredText tParams={`dispatchPage.buttons.hovered.${item.id}`} />
    </Container>
  );
};

export default ButtonsListItemContent;
